// Need to use the React-specific entry point to import createApi
import {apiSlice} from './apiSlice';

export const dataExportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDataExports: builder.query({
      query: filters => {
        const qs = new URLSearchParams();
        if (filters.id) qs.set('id', filters.id);
        return `data_export/?${qs}`;
      },
      providesTags: ['DataExport'],
    }),
    createDataExport: builder.mutation({
      query: body => ({
        url: 'data_export/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['DataExport'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateDataExportMutation,
  useGetDataExportsQuery,
} = dataExportApi;
